import React from 'react';
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/StockChart/delete-bin-5-fill.svg';
import { ReactComponent as ResetIcon } from '../../../../assets/icons/StockChart/replay_24px.svg';
import { ReactComponent as PrintIcon } from '../../../../assets/icons/StockChart/printer-fill.svg';
import SettingsPopup from '../common/SettingsPopup';
import '../../../../Components/Common/typography.css';
import './GeneralSettings.css';

interface GeneralSettingsProps {
  onClearAll: () => void;
  onResetDefault: () => void;
  onPrint: () => void;
}

const GeneralSettings: React.FC<GeneralSettingsProps> = ({
  onClearAll,
  onResetDefault,
  onPrint,
}) => (
  <SettingsPopup className="general-settings-popup">
    <div className="general-settings-row" onClick={onClearAll}>
      <span className="general-settings-icon">
        <DeleteIcon />
      </span>
      <span className="body-m-regular">Clear all</span>
    </div>
    <div className="general-settings-row" onClick={onResetDefault}>
      <span className="general-settings-icon">
        <ResetIcon />
      </span>
      <span className="body-m-regular">Reset to default settings</span>
    </div>
    <div className="general-settings-row" onClick={onPrint}>
      <span className="general-settings-icon">
        <PrintIcon />
      </span>
      <span className="body-m-regular">Print chart</span>
    </div>
  </SettingsPopup>
);

export default GeneralSettings;
